export enum CompetitionTypes {
  ROUND_ROBIN = 1,
  KNOCKOUT = 2,
}
